import * as React from "react";
import Manage from "../../assets/icons/x-lg.svg";
import Icon from "./Icon";

const DeleteIcon = () => {
    var smallStyle = {
        height: 18,
        margin: "0px 8px 0px 0px" 
    }; 

  return (
    <React.Fragment>
          <Icon icon={Manage} text="Delete" id="deleteIcon" style={smallStyle} tooltip={true} />
    </React.Fragment>
  );
};

export default DeleteIcon;
